module.exports = __webpack_public_path__ + "static/media/sandalwood.50a89eed.jpg";